import { BaseEditModel } from "model/BaseEditModel";
import RequisitoAuditoria from "./RequisitoAuditoria";

export class OpcaoRespostaRequisito implements BaseEditModel {
    id: number | null;
    key: string | null = "";
    sequencial: number | null = 0;
    requisitoAuditoria: RequisitoAuditoria | null;
    resposta: string;

    constructor(
        id: number | null = null, 
        requisitoAuditoria: RequisitoAuditoria | null = null, 
        resposta: string = ""
    ) {
        this.id = id;
        this.requisitoAuditoria = requisitoAuditoria;
        this.resposta = resposta;
    }
}